import type { UserBase } from '@recruitee/account-types';
import type { MentionElement } from '@recruitee/prosemirror';
import { MentionType } from '@recruitee/prosemirror';

export const userToMention = (user: UserBase, additionalFields?: any): MentionElement => ({
  id: user.id,
  type: MentionType.User,
  name: `${user.firstName} ${user.lastName}`,
  avatar: user.photoThumbUrl,
  entity: user,
  hasAvatar: user.hasAvatar,
  initials: user.initials,
  ...additionalFields,
});
